import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { DeductibleLookupComponent } from './components/deductible-lookup.component';
import { DeductibleServiceFeesComponent } from './components/deductible-service-fees/deductible-service-fees.component';
import { LazyElementsModule } from '@angular-extensions/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeductibleLookupDeviceComponent } from './components/deductible-lookup-device/deductible-lookup-device.component';
import { DeductibleLookupResultsComponent } from './components/deductible-lookup-results/deductible-lookup-results.component';

@NgModule({
  declarations: [
    DeductibleLookupComponent,
    DeductibleServiceFeesComponent,
    DeductibleLookupDeviceComponent,
    DeductibleLookupResultsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    LazyElementsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DeductibleLookupModule { }
